import { Component, OnInit } from '@angular/core'


@Component({
    
    templateUrl: './medicare-website.component.html'
    
})

export class MedicareWebsite implements OnInit {


    ngOnInit() {
        window.open("https://www.medicare.gov", "_blank");
    }
   
    
}

